// special type mostly for showing to Vendors
// has both rfx and response as nested items, side-by-side
// in components, you can call this an 'item' then use 'item.response' and 'item.rfx' 
// use this because its easier than trying to next Rfx in response AND response in Rfx in different situations


import { Rfx } from './rfx';
import { RfxResponse } from './rfxResponse';
import { 
    HumanizeDateTimeHelper, 
    FormatDateTimeLocal, 
    isFutureDate,
} from '../filters-helpers';
import { DateTime } from 'luxon';


class ResponseWithRfx {
    constructor({  // you can set defaults for constructor params here, or just let them be undefined and set in constructor method
        rfx,
        response,
    }) {
        this.id = response.id ?? response.pk;  // since this is a Response first, use its ID
        this.rfx = new Rfx(rfx);
        this.response = new RfxResponse(response);
        // ADDING MORE calculated/formatted things so we can standardize for 2 different 'viewMode's in vue component

        // RESPONSE BUTTON OBJECT
        const canModify = this.response.can_vendor_modify;
        //const canView = this.response.can_vendor_view;
        //const isSubmitted = this.response.state_dict?.is_submitted;
        const state = this.response.sm_state;
        const isOpenInvite = this.response.sm_state === 'invited';
        let respButton = {  // the defaults
            visible: true,
            disabled: false,
            href: this.response.vendor_url,
            variant: 'minimal-primary',
            text: 'View Response',
        };
        if (isOpenInvite) {
            respButton.visible = false;
        } else if (state === 'started') {
            respButton.variant = 'sharp-primary';
            respButton.text = 'Respond Now';
        } else if (state === 'declined') {
            respButton.text = 'View Response';
        } else if (['queued', 'cancelled', 'unresponded'].includes(state)) {
            respButton.visible = false;
        } else if (state === 'submitted') {
            if (canModify) {
                respButton.variant = 'gray-primary';
                respButton.text = 'Update Response';
            } else {
                respButton.variant = 'minimal-primary';
                respButton.text = 'View Response';
            }
        } else if (state === 'awarded') {
            respButton.variant = 'minimal-primary';
            respButton.text = 'View Response';
        } else if (state === 'rejected') {
            if (canModify) {  // possible
                respButton.variant = 'gray-primary';
                respButton.text = 'Update Response';
            } else {  // likely not possible???  if rejected and cannot modify, likely should not be shown
                respButton.variant = 'minimal-primary';
                respButton.text = 'View Response';
            }
        }
        this.responseButton = respButton;

        // RFX BUTTON
        const rfxButton = {
            variant: isOpenInvite ? 'sharp-primary' : 'minimal-primary',
            href: this.rfx.vendor_url,
            text: `View ${this.rfx.rfx_type}${isOpenInvite ? ' & Start Response' : ''}`,
        };
        this.rfxButton = rfxButton;

        // MAIN URL TO GO TO (based on state of response)
        // now that we have 'View RFx' tab on the response page/component, we don't need 2 separate link buttons
        // but you may still be using 2 link buttons on CARD view -- pay attention
        // just have ONE link button -- if started response, then go to response.  if not started response, then go to RFX page
        // we also use the mainUrl for link on the title of RFX in table view
        this.mainUrl = isOpenInvite ? this.rfx.vendor_url : this.response.vendor_url;
        const mainButton = {
            text: isOpenInvite ? `View ${this.rfx.rfx_type} & Start Response` : this.responseButton.text,
            icon: isOpenInvite ? '' : 'arrow-right',  // no icon when open invites - too long
            variant: isOpenInvite ? this.rfxButton.variant : this.responseButton.variant,
            href: this.mainUrl,
        }
        this.mainButton = mainButton;

        // DEADLINES
        // return boolean if we have a deadline to show or not, and its in the future
        const deadlineLuxon = this.rfx.close_date_to_show;
        this.hasDeadline = !!deadlineLuxon && isFutureDate(deadlineLuxon);
        // we format deadlines WITH time included
        this.deadlineFormatted = FormatDateTimeLocal(deadlineLuxon);  // empty string if no date
        this.deadlineTimeUntil = HumanizeDateTimeHelper(deadlineLuxon);  // 'in 2 days'

        // INVITATION DATE
        const inviteDateLuxon = this.response.invitation_date;
        // we format invitation dates WITHOUT time included.... not so important here
        //this.invitationDateFormatted = FormatDateTimeLocal(inviteDateLuxon);
        this.invitationDateFormatted = (inviteDateLuxon && inviteDateLuxon.isValid) ? inviteDateLuxon.toLocaleString(DateTime.DATE_SHORT) : '';
        this.invitationDateTimeAgo = HumanizeDateTimeHelper(inviteDateLuxon);

    }
}

export {
    ResponseWithRfx,
}